import { composeIO } from 'react-compose-io'
import { tabTipoLancamentoParceiroIO } from './TabTipoLancamentoParceiro.IO'
import TabTipoLancamentoParceiroView from './TabTipoLancamentoParceiro.View'

export const TabTipoLancamentoParceiro = composeIO(TabTipoLancamentoParceiroView, tabTipoLancamentoParceiroIO)
